module.exports = __webpack_public_path__ + "static/media/logo.e91d4a18.png";